// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1852":"dd76a723380a80fa","3846":"17f57c56421d214d","6552":"5da6e5098fc26864","7014":"04e446ce43a62dcd","7919":"ae44bee66ce481aa"}[chunkId] + ".js";
};